// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__39SBj","footer":"ModalCreateQualiphyProcedure_footer__20dYK","additionData":"ModalCreateQualiphyProcedure_additionData__GNfPH"};